module.exports = __webpack_public_path__ + "static/media/triangle.6366578f.svg";